// Lib
import { createSelector } from 'reselect';

// Utils
import { hasSeen } from '../../../common/users/userEducationUtil';

// Selectors
import { getCurrentUserEducation, isGuestSelector } from '../../user/currentUserSelector';

// Constants
import { ONBOARDING_EDUCATION_CODES } from '../../../common/users/userEducationConstants';

/**
 * Only allow mobile landscape mode if the user has completed onboarding.
 */
export const selectIsMobileLandscapeModeAllowed = createSelector(
    isGuestSelector,
    getCurrentUserEducation,
    (isGuest, currentUserEducation) => {
        if (isGuest) return true;

        // If the user hasn't completed onboarding, don't allow landscape mode
        if (hasSeen(currentUserEducation, ONBOARDING_EDUCATION_CODES.DESKTOP_ONBOARDING)) return true;

        return false;
    },
);
